<div class="container">

  <div class="header">
    <h2>Case Mix</h2>
  <button mat-icon-button (click)="closeDialog()" class="closeIcon">
    <mat-icon>close</mat-icon>
  </button>
  </div>

  <div class="card">
    <div class="card-content">
      <div class="summary-cards">
        <div class="summary-card" *ngFor="let item of summaryData">
          <div class="card-label">{{ item.title }}</div>
          <div class="card-value">{{ item.value }}</div>
        </div>
      </div>


      <div class="filters">
        <button class="filter-btn" [class.active]="activeFilter === 'all'" (click)="setFilter('all')">
          All NTAs ({{ allCount }})
        </button>
        <button class="filter-btn" [class.active]="activeFilter === 'ready'" (click)="setFilter('ready')">
          NTA Ready ({{ readyCount }})
        </button>
        <button class="filter-btn" [class.active]="activeFilter === 'stepUp'" (click)="setFilter('stepUp')">
          Step-Up Potential ({{ stepUpCount }})
        </button>
        <button class="filter-btn" [class.active]="activeFilter === 'overCoding'" (click)="setFilter('overCoding')">
          Over-Coding Risk ({{ overCodingCount }})
        </button>
        <button class="filter-btn" [class.active]="activeFilter === 'allZero'" (click)="setFilter('allZero')">
          All Zero ({{ allZeroCount }})
        </button>



        <div class="table-header">

          <button class="filter-btn active" (click)="openAddNtaDialog()"> + Add NTA </button>

          <div class="document-list" *ngIf="documentList && documentList.length > 0">
            <label>Source Documents</label>
            <ng-container *ngFor="let item of documentList">
              <i class="fa fa-file-pdf-o" style="color: red; margin-left: 8px; cursor: pointer;" aria-hidden="true"
                (click)="openDocument(docViewer,item)">
              </i>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="table-container ntaTable">
        <table>
          <thead>
            <tr>
              <th>Status</th>
              <th>Diagnosis</th>
              <th class="icd10-col">ICD-10</th>
              <th>NTA Condition</th>
              <th>Clinical Category</th>
              <th>Points</th>
              <th>Proposed</th>
              <th class="potential-col">Potential ±</th>
              <th>Risk</th>
              <th>Alert</th>
              <th>Include</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!filteredNtaData || (filteredNtaData && filteredNtaData.length == 0)">
              <td colspan="11" class="no-record">No Record Found</td>
            </tr>
            <tr *ngFor="let item of filteredNtaData">
              <td>
                <span class="status-badge" [class.status-definite]="item.status === 'Definite'"
                  [class.status-review]="item.status === 'Review'">
                  {{item.status}}
                </span>
              </td>
              <td>{{item.diagnosis}}</td>
              <td>{{item.icD10}}</td>
              <td>{{item.ntaCondition}}</td>
              <td class="clinical-category">
                <span class="category-badge">{{ item.clinicalCategory }}</span>
              </td>
              <td><span class="points-badge">{{item.ntaPoint}}</span></td>
              <td>{{item.proposedICD10}}</td>
              <td class="potential-col">{{ item.potential }}</td>
              <td class="risk-col">
                <span class="risk-badge" [ngClass]="item.risk">{{ item.risk }}</span>
              </td>
              <td>
                <button  mat-icon-button color="primary" (click)="viewNTADetails(NtaView,item)">
                  <mat-icon>visibility</mat-icon>
                </button>
              </td>
              <td>
                <mat-checkbox [(ngModel)]="item.isInclude" (change)="onCheckboxChange($event,item)">
                </mat-checkbox>
              </td>
              <td>
                <div class="action-buttons">
                  <!-- Trigger button -->
                  <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>

                  <!-- Menu definition -->
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="viewNTADetails(NtaView,item)">
                      <mat-icon>remove_red_eye</mat-icon>
                      <span>View</span>
                    </button>

                    <button mat-menu-item (click)="editNta(item)">
                      <mat-icon>edit</mat-icon>
                      <span>Edit</span>
                    </button>

                    <button mat-menu-item (click)="confirmDelete(item)">
                      <mat-icon color="warn">delete</mat-icon>
                      <span>Delete</span>
                    </button>
                  </mat-menu>
                </div>


              </td>
            </tr>
          </tbody>
        </table>
      </div>




    </div>
  </div>
</div>

<ng-template #NtaView>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>details</mat-icon>
    </span>
     Details
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <!-- <h2 matDialogTitle class="nta-dialog-titles">Details</h2> -->
  <mat-dialog-content class="details-content">
    <div>
      <strong>Description:</strong> {{currentNTA.detailedDescription}}
    </div>
    <div>
      <strong>Location:</strong> {{currentNTA.location_in_patient_Document}}
    </div>
    <div>
      <strong>Threshold:</strong> {{currentNTA.threshold_Condition}}
    </div>
    <div *ngIf="currentNTA.status=='Review'">
      <strong>Step-Up Reason:</strong> {{currentNTA.step_Up_Reason}}
    </div>
    <div *ngIf="currentNTA.status=='Review'">
      <strong>Needed To Qualify:</strong> {{currentNTA.needed_To_Qualify}}
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <!-- <button mat-button color="primary" style="display:none">
      Save
    </button> -->
    <button mat-button color="basic" (click)="close()"> Cancel </button>

  </mat-dialog-actions>
</ng-template>

<ng-template #docViewer>
  <app-document-viewers (getCloseDocumentViewer)="getCloseDocumentViewer($event)" [ngClass]="{ open: documentViewers }"
    [documentpath]="documentPath" [documentType]="fileType" [documentName]="documentname">
  </app-document-viewers>
</ng-template>